<div class="legend-container" *ngIf="!!dataSource.length && data?.showLegend">
  <div class="legend-item" (click)="filterByLegend('impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'impact drivers'">
    <div class="legend-color-box" style="background-color: #DCEAF7;"></div>
    <span>Impact drivers</span>
  </div>
  <div class="legend-item" (click)="filterByLegend('non-impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'non-impact drivers'">
    <div class="legend-color-box" style="background-color: #f2f2f2;"></div>
    <span>Non Impact drivers</span>
  </div>
</div>
<div class="card table-wrapper" [style.height]="data?.height || 'var(--dvm-chart-height-md, 58vh)'">
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="table-scroll-container" *ngIf="!!dataSource.length">
    <div class="table-content-wrapper">
      <!-- Grouped header row (year headers) - uses real table for pixel-perfect alignment -->
      <table class="grouped-header-table" *ngIf="hasGroupedHeaders"
        [class.has-collapsed-cols]="collapsedColumns.size > 0">
        <colgroup>
          <col *ngFor="let col of displayedColumns" [style.width.px]="columnWidths[col]" [style.max-width.px]="columnWidths[col]">
        </colgroup>
        <tr>
          <th *ngFor="let group of headerGroups" class="grouped-header-cell"
            [attr.colspan]="group.columns.length || 1"
            [class.selected-header]="isGroupHeaderSelected(group.label)"
            [class.single-quarter-year-header]="isSingleQuarterYearGroup(group)"
            [class.clickable-header]="!!group.label && !isQuarterlyIdentifierGroup(group)"
            [class.quarterly-static-group]="isQuarterlyIdentifierGroup(group)"
            [class.sticky-col-header]="isQuarterlyIdentifierGroup(group)"
            [style.left.px]="isQuarterlyIdentifierGroup(group) ? getStickyLeftOffset(group.columns[0]) : null"
            (click)="isQuarterlyIdentifierGroup(group) ? null : onGroupHeaderClick(group, $event)">{{ group.label
            }}</th>
        </tr>
      </table>

      <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource" class="custom-table resizable-table"
        [class.has-collapsed-cols]="collapsedColumns.size > 0">
        <colgroup>
          <col *ngFor="let col of displayedColumns" [style.width.px]="columnWidths[col]" [style.max-width.px]="columnWidths[col]">
        </colgroup>
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th class="tableheader" mat-header-cell *matHeaderCellDef
            [class.clickable-header]="!isQuarterlyIdentifierColumn(column)"
            [class.selected-header]="isColumnHeaderSelected(column)" [style.width.px]="columnWidths[column]"
            [class.sticky-col-header]="isQuarterlyIdentifierColumn(column)"
            [style.left.px]="isQuarterlyIdentifierColumn(column) ? getStickyLeftOffset(column) : null"
            [style.min-width.px]="columnWidths[column]"
            [style.max-width.px]="columnWidths[column]"
            [style.left.px]="getFrozenColumnLeft(column)"
            (mousedown)="isColumnCollapsed(column) ? null : onHeaderMouseDown($event, column)"
            (click)="isColumnCollapsed(column) ? toggleColumnCollapse(column, $event) : (isQuarterlyIdentifierColumn(column) ? null : onColumnHeaderClick(column, $event))">
            <div class="header-content" *ngIf="!isColumnCollapsed(column)">
              <span class="header-label">{{ columnLabels[column] }}</span>
              <span class="collapse-col-toggle"
                (mousedown)="$event.stopPropagation()"
                (click)="toggleColumnCollapse(column, $event)"
                title="Collapse column">&#9664;</span>
            </div>
            <span class="collapsed-col-label" *ngIf="isColumnCollapsed(column)"
              [title]="'Expand ' + columnLabels[column]">{{ columnLabels[column] }}</span>
            <!-- Resize handle -->
            <div class="resize-handle" *ngIf="!isColumnCollapsed(column)"
              (mousedown)="onResizeStart($event, column)" (click)="$event.stopPropagation()">
            </div>
          </th>
          <td class="tablebody" mat-cell *matCellDef="let row" (click)="onCellClick(row, column, $event)"
            [class.frozen-col]="isFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.collapsed-col-cell]="isColumnCollapsed(column)"
            [style.width.px]="columnWidths[column]" [style.min-width.px]="columnWidths[column]" [style.max-width.px]="columnWidths[column]"
            [style.left.px]="getFrozenColumnLeft(column)"
            [class.selected-cell]="isCellSelected(row, column)"
            [class.sticky-col]="isQuarterlyIdentifierColumn(column)"
            [style.left.px]="isQuarterlyIdentifierColumn(column) ? getStickyLeftOffset(column) : null"
            [class.highlighted-column]="isColumnHighlighted(column)">
            <span *ngIf="!isColumnCollapsed(column)">{{ row[column] }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
          [style.--frozen-row-top.px]="getFrozenBodyRowTop(i)"
          [style.--frozen-row-bottom.px]="getFrozenBodyRowBottom(i)"
          [ngClass]="{
            'frozen-body-row': isFrozenBodyRow(i),
            'common-background': row.option_impact_drivers?.toLowerCase() === 'impact drivers',
            'non-common-background': row.option_impact_drivers?.toLowerCase() === 'non-impact drivers',
            'even-row': i % 2 === 0,
            'odd-row': i % 2 !== 0
          }">
        </tr>

      </table>
    </div>
  </div>
  @if (!!data?.isPagination && !!dataSource.length ) {
  <app-paginator (pageChange)="onPageChange($event)" #paginatorComp></app-paginator>
  }
</div>
